module.exports = __webpack_public_path__ + "img/ticket_ex4.f5c9fd8a.svg";